import { Utils } from "./utils";

enum StorageKeys {
  DashFilterTagId = "dfti"
}

class StorageUtils {
  private static Get(key: StorageKeys, def: string | null = null) {
    return localStorage.getItem(key.toString()) ?? def;
  }
  private static Set(key: StorageKeys, val: string | null) {
    if (val == null) {
      localStorage.removeItem(key.toString());
    } else {
      localStorage.setItem(key.toString(), val);
    }
  }

  static get DashboardFilterTagId() {
    const val = Utils.ToNumber(this.Get(StorageKeys.DashFilterTagId), null) ?? null;
    // console.log('DashboardFilterTagId Get:', val);
    return val;
  }
  static set DashboardFilterTagId(val: number | null) {
    // console.log('DashboardFilterTagId Set:', val);
    this.Set(StorageKeys.DashFilterTagId, val ? val.toString() : null);
  }

}

export { StorageUtils }